export function round10(x: number) {
  return Math.round(x / 10) * 10
}

export function round5(x: number) {
  return Math.round(x / 5) * 5
}
